// Modules
import { useEffect, useState } from 'react';
import cn from 'classnames';

// Types
import type { TTabPanelProps } from './Tabs.type';

// Styles
import styles from './styles/styles.module.scss';

// Constants
import { TAB_PANEL_DEFAULT_PROPS, TAB_PANEL_TIMEOUT } from './Tab.constant';

const TabPanel = (props: TTabPanelProps) => {
	const {
		active,
		children,
		className,
		slideDirection = TAB_PANEL_DEFAULT_PROPS.slideDirection,
		...restProps
	} = props;
	const [isExpanded, setIsExpanded] = useState<boolean>(false);
	const [isRendered, setIsRendered] = useState<boolean>(false);

	const tabPanelCN = cn(styles.legion_tab_panel, className, {
		[styles[`slide_in_${slideDirection}`]]: isExpanded,
		[styles[`slide_out_${slideDirection}`]]: !isExpanded,
	});

	useEffect(() => {
		const dispose = setTimeout(() => {
			setIsRendered(false);
		}, TAB_PANEL_TIMEOUT);

		if (active) {
			clearTimeout(dispose);
			setIsRendered(true);
			setIsExpanded(true);
		} else {
			setIsExpanded(false);
		}

		return () => {
			clearTimeout(dispose);
		}
	}, [active]);

	return isRendered && (
		<div className={tabPanelCN} {...restProps}>
			{children}
		</div>
	);
}

export default TabPanel;
